const config = {
	api_base_host: process.env.VUE_APP_API_HOST || 'http://bytelang-api.localhost.bytelang.cn',
	node_base_host: process.env.VUE_APP_NODE_HOST || 'http://127.0.0.1:3000',
	version: process.env.VUE_APP_API_VERSION || '/v1',
	websocket_host: process.env.VUE_APP_WS_HOST || 'ws://127.0.0.1:20200',
	host: process.env.VUE_APP_HOST || "http://127.0.0.1:8080/"
};
export default config;
